var map = {
	"./arrow_gallery_left.png": "5d01",
	"./arrow_gallery_right.png": "51e8",
	"./arrow_left.png": "a6ff",
	"./arrow_right.png": "d5b1",
	"./arrow_title_1_left.png": "2946",
	"./arrow_title_1_right.png": "078c",
	"./arrow_title_2_left.png": "b99c",
	"./arrow_title_2_right.png": "0707",
	"./enter.png": "6b75",
	"./gallery-white.png": "37c9",
	"./gallery.png": "a5ec",
	"./laskaridi.jpg": "e3b5",
	"./logo-en.png": "45bb",
	"./logo.png": "9d64",
	"./logo_archives_blue.png": "42a1",
	"./logo_green@3x.png": "bf6e",
	"./logo_laskaridis_blue.png": "505c",
	"./logo_ls.png": "5398",
	"./logo_short.png": "4ee4",
	"./logo_white.png": "5ffc",
	"./logo_white1.png": "4456",
	"./pdf-icon.png": "0056",
	"./pdf/download pdf.svg": "cea0",
	"./pdf/download_pdf.png": "ca2a",
	"./pdf/read online.svg": "0086",
	"./pdf/read_online.png": "d07e",
	"./photo_about.jpg": "356f",
	"./photo_archive.png": "937e",
	"./photo_archive_1.jpg": "93366",
	"./photo_archive_2.jpg": "57c9",
	"./photo_archive_3.jpg": "2305",
	"./photo_bibikou.jpg": "5acb",
	"./photo_contact.jpg": "47d7",
	"./photo_foundation.jpg": "2b6e",
	"./simi-smal.jpg": "e547",
	"./slider_archive-2.png": "8e09",
	"./slider_archive.jpg": "5823",
	"./slider_home.jpg": "6a16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";